module.exports = __webpack_public_path__ + "img/empty.fd053b52.png";